var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoursePublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.995,
    height: 40,
    viewBox: "0 0 39.995 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "publishing",
    d: "M37.77,4.853H34.337V.607A.608.608,0,0,0,33.731,0H6.261a.608.608,0,0,0-.6.607V4.853H2.222A2.224,2.224,0,0,0,0,7.071V32.93a2.225,2.225,0,0,0,2.222,2.222h9.9v3.635H7.879a.607.607,0,0,0,0,1.213H32.121a.607.607,0,0,0,0-1.213H27.874v-3.64h9.9A2.225,2.225,0,0,0,40,32.93V7.071A2.224,2.224,0,0,0,37.77,4.853Zm-30.9-3.64H33.124V29.087H6.867ZM1.213,7.071a1.011,1.011,0,0,1,1.01-1.01H5.662V29.087H1.213ZM26.67,38.783H13.331V35.147H26.661ZM38.788,32.93a1.01,1.01,0,0,1-1.01,1.01H2.222a1.01,1.01,0,0,1-1.009-1.01V30.3H38.78Zm0-3.838H34.337V6.06H37.77a1.011,1.011,0,0,1,1.01,1.011ZM23.607,3.412a.6.6,0,1,1,.43,1.04.611.611,0,0,1-.43-1.04Zm3.662-.177a.607.607,0,1,1-.578.605.607.607,0,0,1,.578-.605ZM30.93,4.268c-.543.566-1.414-.311-.857-.856s1.417.3.854.855ZM29.695,7.676H21.607a.607.607,0,1,1,0-1.211h8.088a.607.607,0,0,1,0,1.211Zm0,4.526H21.607a.607.607,0,1,1,0-1.213h8.088a.607.607,0,0,1,0,1.21Zm-8.088,4.525a.607.607,0,1,1,0-1.213h5.662a.607.607,0,0,1,0,1.213Zm8.088,4.524H18.315a.607.607,0,1,1,0-1.213h11.38a.607.607,0,0,1,0,1.213ZM10.3,20.036h4.782a.607.607,0,0,1,0,1.213H10.31a.607.607,0,0,1-.009-1.213Zm16.968,5.737h-4.64a.607.607,0,0,1,0-1.211h4.646a.607.607,0,0,1-.007,1.211Zm-7.878,0H10.3a.607.607,0,0,1,0-1.211h9.089a.607.607,0,0,1,0,1.211ZM10.3,16.725h8.088a.608.608,0,0,0,.607-.608V7.071a.607.607,0,0,0-.607-.6H10.3a.6.6,0,0,0-.607.6v9.046a.607.607,0,0,0,.607.608Zm.61-9.049h6.867v7.837H10.907Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePublish);
export default __webpack_public_path__ + "static/media/course-publish.80797f44693485d4bf34f3370b093cf2.svg";
export { ForwardRef as ReactComponent };